// Only used for loading in the related content ribbon. You'll know if you
// need it.
import { h, render } from 'preact';

import AdLoader from './utils/ad-loader';
import select from './utils/select';
import Ribbon from './components/Ribbon';

const PRIMARY_GUTEN_TAG = 'subject-2018-elections';
const RELATED_CONTENT_URL = `https://www.texastribune.org/api/v1/content/?content_type=story,audio,video,pointer&tag=${PRIMARY_GUTEN_TAG}&tag!=object-tribcast&fields=id,url,readable_pub_date,headline,short_summary,lead_art&limit=3&format=json`;

export default () => {
  render(<Ribbon />, document.querySelector('#ribbon-container'));

  const loader = new AdLoader({
    targetingKey: 'guten',
    targetingValue: PRIMARY_GUTEN_TAG,
  });

  loader.init();

  const relatedContentList = select('#related-coverage-list');

  fetch(RELATED_CONTENT_URL)
    .then(res => res.json())
    .then(({ results: stories }) => {
      const items = stories.map(story => {
        return `<li class="related-coverage__item" ga-on="click" ga-event-category="Related link" ga-event-action="${
          story.url
        }" ga-event-label="related - GutenTags"><a href="${story.url}">${
          story.headline
        }</a></li>`;
      });

      relatedContentList.innerHTML = items.join('');
    });

  import(/* webpackChunkName: "analytics" */ '@data-visuals/analytics').then(
    analytics => analytics.init()
  );
};



// WEBPACK FOOTER //
// ./main.js